/* eslint-disable */
import _ from 'underscore';

export const getLongHeadlineStyles = ({ styleOverrides }) => () => {
  return {
    longHeadline: _.extend({
    }, styleOverrides.longHeadline),
  };
};
